import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { AttendanceLocal } from "../../../@types/attendance-local";
import { apisiseci } from "../../api";
import { AxiosError } from "axios";

export type AttendanceLocalCreateData = Pick<
    AttendanceLocal,
    | "nome"
    | "bairro"
    | "endereco"
    | "cep"
    | "ativo"
    | "source"
    | "complemento"
    | "slug_unidade"
> & {
    orgao_id: number;
    cidade_id: string;
}

export type CreateAttendanceLocalParams = {
    nome: string;
    orgao_id: number;
    cidade_id: string;
    bairro: string;
    endereco: string;
    cep: string;
    ativo: boolean;
    source?: string;
    complemento?: string;
    slug_unidade?: string;
};

export function useAttendanceLocalCreate() {
    const history = useHistory();
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    const mutation = useMutation<
        AttendanceLocal,
        AxiosError<{ detail: string; }>,
        AttendanceLocalCreateData
    >({
        mutationKey: ["attendance-local", "create"],
        mutationFn: async (data) => {
            return apisiseci.post(
                "/cms/unidades/", data,
                { headers: { Authorization: `Bearer ${token}` } }
            );
        },
        onSuccess: async () => {
            toast.success("Local de atendimento criado com sucesso!");

            await queryClient.invalidateQueries({
                queryKey: ["attendance-local", "list"],
            });

            history.goBack();
        },
        onError: (error) => {
            toast.error(error?.response?.data?.detail || "Algo deu errado, tente novamente!");
            console.log(error);
        },
    });

    return mutation;
}
